import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import MobileUploadWarning from './MobileUploadWarning';
import l10n from '../../shared/strings';
import ua from '../../ua';

export default function ImportListHeader() {
  const items = useSelector((state) => state.import.items);
  const filesCount = useMemo(() => Object.values(items)
    .reduce((sum, filesInCollection) => sum + filesInCollection.length, 0),
  [items]);
  const errorsCount = useSelector((state) => state.import.uploadErrorsCount);

  return (
    <div className="importNumberFiles">
      <If condition={ua.isMobileApp()}>
        <MobileUploadWarning />
      </If>
      <>{l10n.IMPORT.textTotalFilesCount(filesCount)}</>
      <If condition={errorsCount > 0}>
        {l10n.IMPORT.textUploadErrorsCount(errorsCount)}
      </If>
    </div>
  );
}
